export const attributesListKeywordStyle = theme => ({
    chipsDetails: {
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    contentTab: {
        padding: theme.spacing(2),
        border: '1px solid rgba(0, 0, 0, 0.12)',
        whiteSpace: 'normal',
        minHeight: '300px'
    }
})